import { useEffect } from 'react';
import useLocation from './useLocation';

/**
 * To adjust the stacking order of vertical nav so that it doesn't obscure the DnD widget
 * The class being added below is used in SASS files to adjust the z-index of vertical nav
 */
export function useCrmDnDInteraction() {
  const {
    search: queryParamsStr
  } = useLocation();
  useEffect(() => {
    const bodyEl = document.querySelector('body.sticky-global-toolbar');
    if (bodyEl && queryParamsStr && queryParamsStr.includes('interaction=logged')) {
      bodyEl.classList.add('global-nav-crm-dnd-interaction');
      return;
    }
    if (bodyEl) {
      bodyEl.classList.remove('global-nav-crm-dnd-interaction');
    }
  }, [queryParamsStr]);
}